import type { OutputMapping } from '../shared/output-mappings';

export const INVESTIGATION_ID_OUTPUT_OPTION_VALUE = 'built_in:investigation_id';

export type DecisionInput = {
  key: string;
  comment?: string;
  expression: string;
};

export type DecisionInputs = DecisionInput[];

export type AiDecisionFormData = {
  name: string;
  inputs: DecisionInputs;

  customObjective?: string;
  customOutputSchema?: string;

  agentId?: string;
  agentVersionId?: string;
  outputs: OutputMapping[];
};
